<script setup>
defineProps({
  validationErrors: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  label: {
    type: [String, null],
    required: false,
    default: null,
  },
  resizeable: {
    type: Boolean,
    default: false,
  },
});

defineOptions({
  inheritAttrs: false
})

const textareaValue = defineModel({
  type: [String],
  required: true,
});
</script>

<template>
  <div>
    <div class="tw-relative tw-w-full">
      <div class="tw-flex tw-flex-col tw-w-full tw-gap-2">
        <label
          v-if="label"
          :for="$attrs.id"
          class="tw-text-font-neutral-900 tw-font-bold tw-text-base"
        >
          {{ label }}
        </label>

        <textarea
          v-model="textareaValue"
          v-bind="$attrs"
          class="tw-pt-4 tw-h-64 focus-within:tw-border-primary tw-border-neutral tw-resize-none tw-border tw-text-neutral-900 tw-self-stretch tw-px-6 tw-text-base tw-w-full tw-rounded-lg"
          :class="{
            '!tw-border-danger': validationErrors.length > 0,
            'tw-resize-y' : resizeable,
          }"
          type="text"
        />
      </div>

      <small
        v-for="(error, index) in validationErrors"
        :key="index"
        class="tw-text-danger tw-self-baseline tw-absolute tw-block tw-mt-1"
      >{{ error }}</small>
    </div>
  </div>
</template>